module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('background-video'), _vm._v(" "), _c('div', {
    staticClass: "config"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "configPanel"
  }, [_c('label', [_vm._v("Curated Video")]), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.videoSelect
    }
  }, _vm._l((_vm.videoList), function(video) {
    return _c('option', {
      domProps: {
        "value": video.id
      }
    }, [_vm._v(_vm._s(video.title))])
  })), _vm._v(" "), _c('label', [_vm._v("Custom YouTube Video (paste part after ?v= in url)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.background.id
    },
    on: {
      "change": function($event) {
        _vm.update($event.target.value, 'videoId')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Start Time")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.background.params.start
    },
    on: {
      "change": function($event) {
        _vm.update($event.target.value, 'params', 'start')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("End Time")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.background.params.end
    },
    on: {
      "change": function($event) {
        _vm.update($event.target.value, 'params', 'end')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Volume")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.background.params.volume
    },
    on: {
      "change": function($event) {
        _vm.update($event.target.value, 'params', 'volume')
      }
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("video")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16d08bda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/video_config.vue
// module id = 265
// module chunks = 1